import React, { useEffect, useState } from "react";
import {
	GetAllAccessibleCountries,
	GetMyCountries,
} from "../../../api/countryController";
import { GetMyVariables } from "../../../api/variablesController";
import {
	CircularProgress,
	Grid,
	Input,
	ListItemText,
	MenuItem,
	Select,
	Typography,
} from "../../../common/MaterialComponent";
import Shared from "../../../common/shared";
import { useGetComponentStringsContext } from "../../../hooks/useGetComponentStrings";
import CountryModel from "../../../models/Country/CountryModel";
import VariablesModel from "../../../models/Variables/VariablesModel";
import { ErrorPage } from "../../ErrorPage/ErrorPage";
import { VariablesListDataGrid } from "../ListDataGrid/VariablesListDataGrid";

export const VariablesList: React.FC = () => {
	const [mounted, setMounted] = useState(false);
	const [selectedCountry, setSelectedCountry] = useState<string>("");
	const [countryList, setCountryList] = useState<CountryModel[]>([]);
	const [error, setError] = useState<string>("");
	const [variablesList, setVariablesList] = useState<VariablesModel[]>([]);
	const [variablesUpdate, setVariablesUpdated] = useState<boolean>(true);

	const strings = useGetComponentStringsContext().VariablesList;

	useEffect(() => {
		const getCountryList = async () => {
			try {
				const res = Shared.isUserRoleGlobalAdmin()
					? await GetAllAccessibleCountries()
					: await GetMyCountries();
				if (res.error) {
					setError(res.error);
				} else {
					setCountryList(res.responseObj ? res.responseObj : []);
					setMounted(true);
				}
			} catch (err) {
				setError(err);
			}
		};

		getCountryList();
	}, []);

	useEffect(() => {
		setMounted(false);
		const getVariablesList = async () => {
			try {
				const res = await GetMyVariables(selectedCountry);
				if (res.error) {
					setError(res.error);
				} else {
					setVariablesList(res.responseObj ? res.responseObj : []);
					setMounted(true);
				}
			} catch (err) {
				setError(err);
			}
		};
		if (selectedCountry && variablesUpdate) {
			getVariablesList();
			setVariablesUpdated(false);
		}
	}, [selectedCountry, variablesUpdate]);

	const onSelectedCountryChange = (
		event: React.ChangeEvent<{ value: unknown }>
	) => {
		setSelectedCountry(event.target.value as string);
		setVariablesUpdated(true);
	};

	return (
		<div>
			{error ? (
				<ErrorPage message={strings.variablesListErrorMessage} />
			) : !mounted ? (
				<div className="loader">
					<CircularProgress size={50} />
				</div>
			) : (
				<>
					<Grid container spacing={3}>
						<Grid item xs={12}>
							<Typography>Selected Country:</Typography>
							<Select
								value={selectedCountry}
								input={<Input />}
								onChange={onSelectedCountryChange}
								style={{ width: "30%" }}
							>
								{countryList.map((country) => (
									<MenuItem key={country.id} value={country.id}>
										<ListItemText primary={country.id} />
									</MenuItem>
								))}
							</Select>
						</Grid>
						{selectedCountry !== "" && (
							<Grid item xs={12}>
								<VariablesListDataGrid
									setVariablesUpdated={setVariablesUpdated}
									variablesList={variablesList}
									country={selectedCountry}
								/>
							</Grid>
						)}
					</Grid>
				</>
			)}
		</div>
	);
};
